module.exports = __webpack_public_path__ + "static/img/studio-logo-new.4f0142f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/studio-logo-new.png
// module id = oZPT
// module chunks = 46